module.exports = __webpack_public_path__ + "static/media/product23.a3c7aec1.jpg";